import React from 'react';

import Form from '../Form';
import InputConsent from '../InputConsent';
import ButtonPrimary from '../ButtonPrimary';

import useForm from './useForm';

const CreditBlockForm = ({ status }) => {
  const {
    form,
    handleSubmit,
    isSubmitting,
  } = useForm();

  return (
    <Form form={form} onSubmit={handleSubmit}>
      <InputConsent label={`I acknowledge that I have un${status} my credit file.`} />
      <ButtonPrimary isLoading={isSubmitting}>
        {`I Have Un${status} My File`}
      </ButtonPrimary>
    </Form>
  );
};

export default CreditBlockForm;
